import { Check, X } from "lucide-react";
import { InfoPopupButton } from "@/components/ui/InfoPopupButton";
import { cn } from "@/lib/utils";

type ReservePriceStatusProps = {
  reached: boolean;
  label: string;
  infoTitle: string;
  infoDescription: string;
  /** Compact variant for collapsed mobile bidding bar */
  compact?: boolean;
  className?: string;
};

export function ReservePriceStatus({
  reached,
  label,
  infoTitle,
  infoDescription,
  compact = false,
  className,
}: ReservePriceStatusProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 min-w-0 max-w-full",
        className,
      )}
    >
      {reached ? (
        <Check
          className={cn(
            "shrink-0 text-green-600 dark:text-green-500 stroke-[2.5]",
            compact ? "h-3.5 w-3.5" : "h-4 w-4",
          )}
          aria-hidden
        />
      ) : (
        <X
          className={cn(
            "shrink-0 text-red-600 dark:text-red-500 stroke-[2.5]",
            compact ? "h-3.5 w-3.5" : "h-4 w-4",
          )}
          aria-hidden
        />
      )}
      <span
        className={cn(
          "font-medium truncate",
          compact ? "text-xs" : "text-sm md:text-xs",
          reached
            ? "text-green-700 dark:text-green-400"
            : "text-red-700 dark:text-red-400",
        )}
      >
        {label}
      </span>
      <InfoPopupButton title={infoTitle} description={infoDescription} />
    </div>
  );
}

/** Derive reached/null from bid + reserve; null when no reserve is set. */
export function getReservePriceReached(
  reservePrice: number | null | undefined,
  currentBid: number | null | undefined,
): boolean | null {
  if (reservePrice == null || reservePrice <= 0) return null;
  const bid = currentBid != null && currentBid > 0 ? currentBid : 0;
  return bid > 0 ? bid >= reservePrice : false;
}
